import ie from "@/assets/js/functions/checkIE.js";
export default {
  name: "english-question",
  props: {
    question: Object,
    bgColors: Object,
    bool: Object,
    isIE : Boolean,
    examFlameHeight: Function,
    dragOver : Function,
    dragLeave : Function,
    drop: Function,
    getTextHtml: Function,
  },
  data: function() {
    return {
      blankStylings: {
				border: '2px solid rgba(0,153,220,1)', 
        minWidth: '33.33%',
        height: '22px',
				textAlign: 'center', 
        borderRadius: '3px', 
        paddingBottom : '1.5px',
       //paddingTop : '1.5px',
        //marginTop : '3px',
				// margin: '0.7rem',
        marginRight: "0.25rem !important",
       // position : 'relative',
				//marginLeft: '0',
				// marginTop: '0',
				// display: 'inline-block',
        display: 'inline-block',
      },
      questionColor: 'rgb(0, 84, 122) !important',
      circleStyle : {
        width: '15px',
        height : '15px',
        marginTop: '2.5px',
        marginLeft : 'auto',
        marginRight : 'auto',
        left : '0px',
        right : '0px',
        borderRadius: '50%',
        textAlign: 'center',
      //  position : 'absolute',
        fontSize: '10px',
        border:' 0.1em solid #666',
        //display : 'inline-block',
        boxSizing: 'initial'
      }
    }
  },
  mounted: function() {
    if(this.isIE){
      this.circleStyle.fontSize = '9px';
      this.circleStye.marginTop = '1px';
    }
  },
};
